export default __webpack_public_path__ + "static-front/media/BackspaceIcon.b36c02df.svg";